module.exports = __webpack_public_path__ + "img/newsLogo8.103339f7.png";